import { gql } from "@apollo/client";
import { alpha } from "@mui/material";
import { PageContentStack } from "atoms/Stack";
import Stack from "atoms/Stack";
import { MAX_CONTENT_WIDTH } from "helpers/breakpoints";
import { COLOR_BLACK, COLOR_WHITE_LIGHTER, TEAM_COLORS } from "helpers/colors";
import { SPACING } from "helpers/spacings";
import useData from "helpers/useData";
import useEnforceAuth from "helpers/useEnforceAuth";
import useRouteState from "helpers/useRouteState";
import Section from "molecules/Section";
import React from "react";
import { Bar, BarChart, CartesianGrid, LabelList, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { TeamPageTitle } from "shared/PageTitle";

import TeamPagesHeader from "./team/TeamPagesHeader";
import TeamSeasonSelectSubnav from "./team/TeamSeasonSelectSubnav";

export default function TeamSeasonPage({ teamId }) {
  useEnforceAuth({ enforceAuthenticated: true });
  const [seasonId, seasonIdSet] = useRouteState("seasonId");
  const [data] = useData(
    gql`
      query TeamSeasonPage($teamId: ID!, $seasonId: ID!) {
        team(id: $teamId) {
          id
          name
          colour
          seasonGraphEntries(seasonId: $seasonId) {
            playedOn
            score
            againstTeamScore
            againstTeam {
              id
              name
            }
          }
        }
      }
    `,
    { teamId, seasonId },
  );
  const teamColor = TEAM_COLORS[data?.team?.colour];

  return (
    <>
      <TeamPageTitle title="Season" />
      <TeamPagesHeader teamId={teamId} tab="season" />
      <div
        style={{
          backgroundColor: COLOR_WHITE_LIGHTER,
          borderBottom: `1px solid ${alpha(COLOR_BLACK, 0.1)}`,
        }}
      >
        <TeamSeasonSelectSubnav teamId={teamId} seasonId={seasonId} seasonIdSet={seasonIdSet} />
      </div>
      <PageContentStack>
        <Stack
          gap={SPACING}
          style={{ margin: "0 auto", maxWidth: MAX_CONTENT_WIDTH, width: `calc(100vw - ${SPACING} * 2)` }}
        >
          <Section title="Season Graph">
            {data?.team && (
              <div style={{ height: "50vh" }}>
                <ResponsiveContainer width="100%" height="100%">
                  <BarChart
                    data={data.team.seasonGraphEntries.map((entry) => ({
                      ...entry,
                      title: `vs ${entry.againstTeam.name}`,
                    }))}
                  >
                    <XAxis dataKey="title" angle={20} />
                    <YAxis />
                    <Tooltip />
                    <CartesianGrid stroke="#aaa" />
                    <Bar name="Team Score" dataKey="score" fill={teamColor}>
                      <LabelList dataKey="score" position="top" />
                    </Bar>
                    <Bar name="Opponent Score" dataKey="againstTeamScore" fill="#ccc">
                      <LabelList dataKey="againstTeamScore" position="top" />
                    </Bar>
                  </BarChart>
                </ResponsiveContainer>
              </div>
            )}
          </Section>
        </Stack>
      </PageContentStack>
    </>
  );
}
